import useRouter from 'js/lib/useRouter';

const useZoomDev = (): boolean => {
  const router = useRouter();
  return !!router.location.query?.isDev;
};

export default useZoomDev;
